// this is a transision page
import React, { useEffect } from "react"
import { Container } from "reactstrap"
import { withTranslation } from "react-i18next"
import PageBreadCrumbAndTitle from "components/TP/Common/General/PageBreadCrumbAndTitle"
import { convertNameToRoute } from "utils"
import { claimPaths } from "common/data/routePaths"
import { useAuthHooks, useCustomNavigate, useFlattenModules } from "hooks"
import { ModalSpinner } from "components/TP/Common/Forms"

const HomePage = ({ t }) => {
  const { navigateToReplace } = useCustomNavigate()

  const { subModules, loading, hasFetched } = useFlattenModules()
  const { isCustomer, isReinsurer } = useAuthHooks()

  useEffect(() => {
    if (!hasFetched) return // wait until modules have loaded
    if (isCustomer) {
      navigateToReplace(claimPaths.claimForm)
    } else if (isReinsurer && subModules?.length) {
      const firstModule = subModules[0]
      navigateToReplace(convertNameToRoute(firstModule?.name))
    } else {
      navigateToReplace("/not-found")
    }
  }, [isCustomer, isReinsurer, subModules, hasFetched])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <PageBreadCrumbAndTitle title="Home" />
          {loading ? (
            <div className="d-flex h-100 w-100 align-items-center justify-content-center">
              <ModalSpinner color="primary" />
            </div>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(HomePage)
